import React from 'react';
import { Link } from 'react-router-dom';
import './InnovationContent.css';


const InnovationContent = () => {
    return (
        <div className="Innovation-container">
            <div className="Page-Main_Dec">
                <h1 className="Page-title_LowerCase">Innovation</h1>
                <nav className="innovation-breadcrumb" style={{ margin: '4px 0 12px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                    <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                    <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                    <span>Innovation</span>
                </nav>
            </div>

            <div className="Innovation-section">
                <div className="Innovation-image">
                    <img src="/Assets/InnovationImages/Innovation.webp" />
                </div>
                <div className="Innovation-text">
                    <p>Callistus’ Passion is Innovation. We believe that innovation in blinds brings a new dimension and pleasure in the living space which enhances happiness in life by offering Light Control according to the need, mood, and Privacy. We have the World’s largest range of 15 Types of Blinds, 10 Operating Systems, and 2000+ shade options to match and beautify the interior.</p>
                </div>
            </div>

            <div className="Innovation-section">
                <div className="Innovation-image">
                    <img src="/Assets/InnovationImages/conversion-1.webp" />
                </div>
                <div className="Innovation-text">
                    <h4>1st Time for Roman Blinds - Unique Fabric Conversion option</h4>
                    <p>Callistus Roman Blinds offer to convert visible fabric to Translucent or Blackout, and Translucent fabric to Blackout by using lining fabric. So now, you have an option to utilize the same fabric in multiple ways at various locations to control Light, Privacy and Heat as per your mood and need.</p>
                </div>
            </div>


            <div className="Innovation-section">
                <div className="Innovation-image">
                    <img src="/Assets/InnovationImages/patricia.webp" />

                </div>
                <div className="Innovation-text">
                    <h4>Patricia Blinds</h4>
                    <p>Patricia Blinds are luxurious to look at and are the latest trendsetter in interior designing. They fold up in the most stylish manner forming a unique flower pattern towards the bottom that makes the room look magnificent even when the blinds are open. They come in a variety of colors and textures that match any interior.</p>
                </div>
            </div>

            <div className="Innovation-section">
                <div className="Innovation-image">
                    <img src="/Assets/InnovationImages/aric-1.webp" />
                </div>
                <div className="Innovation-text">
                    <h4>Aric Blinds</h4>
                    <p>An innovative operating system introduced for the first time in GCC. Aric Blinds offer customers a unique experience with operations of Roller and Vertical blinds simultaneously. They have an exclusive feature that facilitates the opening and closing of the sheer part at the same position of the blind without rolling the blind up or down. Enjoy the features of Roller & Vertical Blinds from Aric Blinds.</p>
                </div>
            </div>
        </div>
    );
};

export default InnovationContent;